import MediaInfoFactory from 'mediainfo.js';
import {initSentry, captureException} from '../../../lib/sentry';

var $form = $('form[data-report-post-form]');
if ($form.length > 0) {
  initSentry();
}
var $submit = $form.find('.js-submittable');
var INVALID_FORMATS = ['ProRes', 'ARRI', 'RED'];
var userAgent = window.navigator.userAgent.toLowerCase();
var isIE = userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1;

/**
 * ReportItemVideoFile用のパラメーター作成
 * @param   {file}    file
 * @param   {string}  itemId
 * @param   {string}  filename
 * @return  {string}  previewItem
 */
function buildVideoPreview(file, itemId, filename) {
  var deleteButton = '<span class="video-preview__delete" style="display: inline;"><a><i class="fa fa-times" aria-hidden="true"></i></a></span>';
  var videoPreview = '<span class="video-preview__file" data-cy="report-item-video-preview-file"> ' + file.name + ' ' + deleteButton + '</span>';
  var fileName = '<input type="hidden" name="report_item[video][' + itemId + '][][filename]" value="' + filename + '">';
  var originalFileName = '<input type="hidden" name="report_item[video][' + itemId + '][][original_filename]" value="' + file.name + '">';
  var originalContentType = '<input type="hidden" name="report_item[video][' + itemId + '][][original_content_type]" value="' + file.type + '">';
  var originalFileSize = '<input type="hidden" name="report_item[video][' + itemId + '][][original_filesize]" value="' + file.size + '">';
  var previewItem = '<li class="video-preview__item">' + videoPreview + fileName + originalFileName + originalContentType + originalFileSize + '</li>';

  return previewItem;
}

/**
 * ファイルアップロードフォームを無効化する
 * @param {jQuery}  $fileElement  ファイルアップロードフォーム要素
 */
function disableFileUploadForm($fileElement) {
  var $uploadForm = $fileElement.closest('.report-item-video-fileupload');
  var $label = $uploadForm.find('.report-item-media-fileupload-label');

  // 投稿ボタンの無効化
  $submit.prop('disabled', true);

  // ファイルアップロードフォームの無効化
  $label.addClass('is-disabled');
  $fileElement.addClass('is-disabled').prop('disabled', true);
}

/**
 * ファイルアップロードフォームを有効化する
 * @param {jQuery}  $fileElement        ファイルアップロードフォーム要素
 * @param {bool}    isUploadSuccessed   ファイルアップロード 正常終了
 */
function enableFileUploadForm($fileElement, isUploadSuccessed) {
  var $uploadForm = $fileElement.closest('.report-item-video-fileupload');
  var $label = $uploadForm.find('.report-item-media-fileupload-label');

  // ファイルアップロードフォームの初期化
  $fileElement.val('');

  // ファイルアップロードフォームの有効化
  // ファイルアップロードが異常終了した場合、アップロードフォームを有効化
  if (!isUploadSuccessed) {
    $label.removeClass('is-disabled');
    $fileElement.removeClass('is-disabled').prop('disabled', false);
  }

  // 投稿ボタンの有効化
  // ファイルアップロード中の（value にファイル名が設定されている）フォーム要素がなければ投稿ボタンを有効化する
  // （複数動画ファイル対応）
  var uploadingFiles = [];
  $form.find('input[type="file"].upload__report-item-video').each(function () {
    if ($(this).val()) {
      uploadingFiles.push($(this).val());
    }
  });
  if (uploadingFiles.length === 0) {
    $submit.prop('disabled', false);
  }
}


/**
 * 動画ファイルのアップロード
 * @param {jQuery}  $fileElement
 * @param {string}  url
 * @param {string}  filename
 * @param {number}  videoSourceId
 */
function uploadVideo($fileElement, url, filename, videoSourceId) {
  var file = $fileElement[0].files[0];
  var companyId = $fileElement.data('company-id');
  var userId = $fileElement.data('user-id');
  var reportId = $fileElement.data('report-id');
  var itemId = $fileElement.data('item-id');
  var minFileSize = 1; // 動画が0Bとなる不具合のエラー通知用
  var maxFileSize = 1024 * 1024 * 1024 * 4; // 4GB
  var allowedFileExtensions = new RegExp('\.(mov|mp4|wmv)$', 'i');
  var allowedTypes = ['video/quicktime', 'video/mp4', 'video/x-ms-wmv'];

  if (file.size < minFileSize) {
    toastr.error('動画をアップロードできません。お手数ですがブラウザから再度ログインしてお試しください。');
    enableFileUploadForm($fileElement);
    return false;
  } else if (file.size > maxFileSize) {
    toastr.error('動画サイズが容量制限を超えています。4GB以下にしてください。');
    enableFileUploadForm($fileElement);
    return false;
  }

  // 「拡張子がmov, mp4, wmv」かつ「content_typeがvideo/quicktime, video/mp4, video/x-ms-wmvではない」ものをbugsnagで検知
  if (allowedFileExtensions.test(file.name) && allowedTypes.indexOf(file.type) === -1) {
    captureException(
      'InvalidVideoFile ContentTypeError',
      'company_id = ' + companyId +
      ', user_id = ' + userId +
      ', report_id = ' + reportId +
      ', filename: ' + filename +
      ', original_filename: ' + file.name +
      ', original_content_type: ' + file.type +
      ', filesize: ' + file.size
    );
  }

  // 「拡張子がmov,mp4,wmv」以外であればアップロードしない
  if (!allowedFileExtensions.test(file.name)) {
    toastr.error('動画のファイル形式が対応していないため、アップロードできません。');
    enableFileUploadForm($fileElement);
    return false;
  }

  var $uploadForm = $fileElement.closest('.report-item-video-fileupload');

  // プログレスバーの作成
  var forIdByName = filename;
  var $progress = $uploadForm.find('.video-preview__progress');
  var $progressBar = $('<progress id="' + forIdByName + '" class="video-preview__progress-bar" value="0" max="100"></progress>').appendTo($progress);

  // ファイルのアップロード
  $.ajax({
    type: 'PUT',
    url: url,
    data: file,
    processData: false,
    contentType: file.type,
    cache: false,
    async: true,
    xhr: function () {
      var xhr = $.ajaxSettings.xhr();
      if (xhr.upload) {
        xhr.upload.addEventListener('progress', function (e) {
          var percent = parseInt(e.loaded / e.total * 10000) / 100;
          $progressBar.val(percent);
        }, false);
      }
      return xhr;
    }
  }).done(function () {
    $progressBar.remove();

    $.ajax({
      url: '/api/v1/video_sources/' + videoSourceId + '/update_status',
      type: 'PATCH',
      data: {
        status: 'processing'
      }
    }).done(function () {
      toastr.success('アップロードが完了しました。');
      enableFileUploadForm($fileElement, true);
      
      var $uploadForm = $fileElement.closest('.report-item-video-fileupload');
      var $preview = $uploadForm.find('.video-preview');
      var $previewList = $('.video-preview__list-' + itemId).length ? $('.video-preview__list-' + itemId)
                                                                    : $('<ul class="video-preview__list video-preview__list-' + itemId + '"></ul>').appendTo($preview);
      $previewList.append(buildVideoPreview(file, itemId, filename));
    }).fail(function (jqXHR) {
      toastr.error('動画のアップロードに失敗しました。再度ファイルを選択して下さい。');
      captureException(
        '動画アップロードエラー: PATCH /api/v1/video_sources/' + videoSourceId + '/update_status ' +
        'url = ' + url +
        ', company_id = ' + companyId +
        ', user_id = ' + userId +
        ', report_id = ' + reportId +
        ', filename: ' + filename +
        ', original_filename: ' + file.name +
        ', original_content_type: ' + file.type +
        ', filesize: ' + file.size +
        ', statusCode: ' + jqXHR.status +
        ', errorResponseText: ' + jqXHR.responseText
      );

      enableFileUploadForm($fileElement);
      return false;
    });
  }).fail(function (jqXHR) {

    // jqXHR.status: 0 => 通信エラー
    var errorMessage = jqXHR.status === 0 ? '通信エラーにより動画のアップロードに失敗しました。通信環境をご確認のうえ、再度お試しください。'
                                          :'動画のアップロードに失敗しました。再度お試しください。'

    toastr.error(errorMessage);

    // 通信エラー以外のときだけBugsnagで通知を飛ばす
    if(jqXHR.status !== 0) {
      captureException(
        '動画アップロードエラー: PUT AWS S3 ' +
        'url = ' + url +
        ', company_id = ' + companyId +
        ', user_id = ' + userId +
        ', report_id = ' + reportId +
        ', filename: ' + filename +
        ', original_filename: ' + file.name +
        ', original_content_type: ' + file.type +
        ', filesize: ' + file.size +
        ', statusCode: ' + jqXHR.status +
        ', errorResponseText: ' + jqXHR.responseText
      );
    }

    $progressBar.remove();
    enableFileUploadForm($fileElement);
  });
}

// 画像ドラッグ・アンド・ドロップのブラウザデフォルト動作停止
$(document).on('drop dragover', function (e) {
  e.preventDefault();
});

// ファイル選択時の処理
$form.find('input[type="file"].upload__report-item-video').each(function () {
  var $fileElement = $(this);

  $fileElement.change(function () {
    // アップロードフォームの無効化
    disableFileUploadForm($fileElement);

    // IEの場合は、WebAssembly がサポートされていないため、webinfo.js でコーデックの判定をしない
    if(isIE) {
      $.ajax({
        url: '/api/v1/video_sources',
        type: 'POST',
        data: {
          resource_type: 'report',
          original_filename: file.name
        }
      }).done(function(response) {
        uploadVideo($fileElement, response.video_source.presigned_upload_url, response.video_source.filename, response.video_source.id);
      }).fail(function(jqXHR) {
        toastr.error('動画のアップロードに失敗しました。再度ファイルを選択して下さい。');
        captureException(
          '動画アップロードエラー: POST /api/v1/video_sources ' +
          'company_id = ' + companyId +
          ', user_id = ' + userId +
          ', report_id = ' + reportId +
          ', original_filename: ' + file.name +
          ', original_content_type: ' + file.type +
          ', filesize: ' + file.size +
          ', statusCode: ' + jqXHR.status +
          ', errorResponseText: ' + jqXHR.responseText
        );
        enableFileUploadForm($fileElement);
      });
    } else {
      // 動画のフォーマットチェック処理 https://github.com/buzz/mediainfo.js を利用している
      MediaInfoFactory({format: 'object', locateFile: function () {return '/MediaInfoModule.wasm';}}).then(function (mediainfo) {
        var file = $fileElement[0].files[0];
        var companyId = $fileElement.data('company-id');
        var userId = $fileElement.data('user-id');
        var reportId = $fileElement.data('report-id');

        if (file) {
          var getSize = function getSize() {
            return file.size;
          };

          // Blob.slice() を利用して動画ファイルを分割読み込みしている。
          // 一部分だけを用いて判定するため、大きな動画ファイルであっても読み込み負荷や時間はかからない
          var readChunk = function readChunk(chunkSize, offset) {
            return new Promise(function (resolve, reject) {
              var reader = new FileReader();
              reader.onload = function (event) {
                if (event.target.error) {
                  reject(event.target.error);
                }
                resolve(new Uint8Array(event.target.result));
              };
              reader.readAsArrayBuffer(file.slice(offset, offset + chunkSize));
            });
          };
          // フォーマットが、ProRes の場合、変換できないためエラーを返す
          mediainfo.analyzeData(getSize, readChunk).then(function (result) {
            var video_format = result.media.track[1]['Format'];
            if (INVALID_FORMATS.includes(video_format)) {
              toastr.error('アップロードされた動画のコーデックは対応していません。対応したコーデック(MPEG-4, H.246など)で再度アップロードしてください。');
              // ファイルアップロードフォーム 有効化
              enableFileUploadForm($fileElement);
              return false;
            }
            $.ajax({
              url: '/api/v1/video_sources',
              type: 'POST',
              data: {
                resource_type: 'report',
                original_filename: file.name
              }
            }).done(function(response) {
              uploadVideo($fileElement, response.video_source.presigned_upload_url, response.video_source.filename, response.video_source.id);
            }).fail(function(jqXHR) {
              toastr.error('動画のアップロードに失敗しました。再度ファイルを選択して下さい。');
              captureException(
                '動画アップロードエラー: POST /api/v1/video_sources ' +
                'company_id = ' + companyId +
                ', user_id = ' + userId +
                ', report_id = ' + reportId +
                ', original_filename: ' + file.name +
                ', original_content_type: ' + file.type +
                ', filesize: ' + file.size +
                ', statusCode: ' + jqXHR.status +
                ', errorResponseText: ' + jqXHR.responseText
              );
              enableFileUploadForm($fileElement);
            });
          }).catch(function (error) {
            console.log('An error occurred:' + error.stack);
            toastr.error('動画のアップロードに失敗しました。再度ファイルを選択してください。');
            captureException(
              '動画アップロードエラー: mediainfo' +
              'url = ' + url +
              ', company_id = ' + companyId +
              ', user_id = ' + userId +
              ', report_id = ' + reportId +
              ', error.stack = ' + error.stack
            );
          });
        }
      }).catch(function (error) {
         toastr.error('動画のアップロードに失敗しました。時間をおいて再度ページを読み込み直してください。');
         captureException(
           'error: mediainfo' +
           'url = ' + url +
           ', error.stack = ' + error.stack
         );
      });
    }
  });
});

// アップロードキャンセル（動画削除）
$form.on('click', '.video-preview__delete', function () {
  var $previewItem = $(this).closest('.video-preview__item');
  var $uploadForm = $previewItem.closest('.report-item-video-fileupload');
  var $fileElement = $uploadForm.find('input[type="file"].upload__report-item-video');

  // プレビュー削除
  $previewItem.remove();

  // ファイルアップロードフォーム 有効化
  enableFileUploadForm($fileElement);
});
